export const pageBuilderTemplate = 'page-builder';
